// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource-type-deck img {\n\topacity: 0.4 !important;\n}\n\n.resource-type-deck:hover img {\n\topacity: 0.7 !important;\n}\n", "",{"version":3,"sources":["webpack://css/collections.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":[".resource-type-deck img {\n\topacity: 0.4 !important;\n}\n\n.resource-type-deck:hover img {\n\topacity: 0.7 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
